<template>
    <div class="p-grid p-fluid dashboard">
        <div class="card">
            <Toolbar class="mb-4">
                <template slot="left">
                    <Button label="Nuevo" icon="pi pi-plus" class="p-button-success p-mr-2" @click="nuevoRegistro" />
                </template>
            </Toolbar>
			<br>
			<DataTable
                class="p-datatable-gridlines p-datatable-striped p-datatable-sm p-datatable-responsive p-datatable-customers"
                :value="dataValoresAdicionales"
                :rowHover="true"
                dataKey="id"
                :paginator="true"
                :rows="10"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Mostrar {first} hasta {last} de {totalRecords} Registros">
                <template #empty> No se encontraron Registros. </template>
                <template #loading> Cargando Registros, por favor espere un momento. </template>
                <Column field="documento" header="Documento" headerStyle="width: 10em;">
                    <template #body="slotProps">
                        <span class="p-column-title"> Documento:</span>
                        {{ slotProps.data.documento }}
                    </template>
                </Column>
				<Column field="descripcion" header="Descripción">
                    <template #body="slotProps">
                        <span class="p-column-title"> Descripción:</span>
                        <span  :class="'customer-badge'">{{ slotProps.data.descripcion }} </span>
                    </template>
                </Column>
                <Column field="cantidad" header="Cantidad" headerStyle="width: 5em;">
                    <template #body="slotProps">
                        <span class="p-column-title"> Cantidad:</span>
                        <span  :class="'customer-badge'">{{ slotProps.data.cantidad }} </span>
                    </template>
                </Column>
                <Column field="valorunitario" header="Val. unit" headerStyle="width: 5em;">
                    <template #body="slotProps">
                        <span class="p-column-title"> Val. unit:</span>
                        <span  :class="'customer-badge'">{{ slotProps.data.valorunitario }} </span>
                    </template>
                </Column>
                <Column field="subtotal" header="Subtotal" headerStyle="width: 5em;">
                    <template #body="slotProps">
                        <span class="p-column-title"> Subtotal:</span>
                        <span  :class="'customer-badge'">{{ slotProps.data.subtotal }} </span>
                    </template>
                </Column>
                <Column headerStyle="width: 4em;">
                    <template #body="slotProps">
                        <Button icon="pi pi-trash" class="p-button-rounded p-button-danger p-mr-2" v-tooltip="'Eliminar registro'" @click="eliminar(slotProps.data)" />
                    </template>
                </Column>
            </DataTable>
        </div>
        <Dialog :visible.sync="adicionalesDialog" :contentStyle="{'overflow': 'visible'}" :style="{ width: '500px' }" :header="textoAdicional" position="top" @hide="cerrarModalItem()">
			<div class="col-md-12 p-lg-12">
				<div class="p-field p-grid">
                    <div class="row p-col-12 p-md-12">
                        <label for="documento" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Documento: </label>
                        <div class="p-col-12 col-md-10">
                            <Dropdown id="documento" 
								:options="documentoLista" 
								v-model="documentoSeleccionado"
								optionLabel="descripcion" 
								dataKey="id"
								placeholder="Seleccionar documento">
							</Dropdown>
                        </div>
                    </div>
                    <div class="row p-col-12 p-md-6">
                        <label for="valor" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">V. unit: </label>
                        <div class="p-col-12 col-md-10">
                            <InputText id="valor" type="text" v-model="valorunitario" />
                        </div>
                    </div>
                    <div class="row p-col-12 p-md-6">
                        <label for="valor" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Cantidad: </label>
                        <div class="p-col-12 col-md-10">
                            <InputNumber id="valor" type="text" v-model="cantidad" />
                        </div>
                    </div>
                    <div class="row p-col-12 p-md-12">
                        <label for="valor" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Descripción: </label>
                        <div class="p-col-12 col-md-10">
                            <InputText id="valor" type="text" v-model="descripcion" />
                        </div>
                    </div>
                </div>
			</div>
			<template #footer>
                <Button label="Grabar" icon="pi pi-save" class="p-button-primary p-mr-2" @click="grabarDetallePlanilla()" />
				<Button label="Salir" icon="pi pi-times" class="p-button-warning p-mr-2" @click="cerrarModalItem()" />
			</template>
		</Dialog>
        <DialogProgreso
            :showProgreso="showProgreso"
            :titulo="mensajeCargando">
        </DialogProgreso>
    </div>
</template>

<script>
import PlanillaService from "../../../service/administracion/PlanillaService";
import DialogProgreso from "../../componentesglobales/DialogoProgreso.vue";
import DocumentoService from "../../../service/administracion/DocumentoService";
import Swal from 'sweetalert2';

export default {
    name: 'ValoresAdicionalesPlanilla',
    props: {
        cliente:{
            type: Object,
            default: null,
        },
        mes:{
            type: Object,
            default: null,
        },
        anio:{
            type: Object,
            default: null,
        }
    },
    data(){
        return{
            dataValoresAdicionales: [],
            showProgreso: null,
            mensajeCargando: null,

            documentoLista: [],
            documentoSeleccionado: {},
            valorunitario: null,
            cantidad: null,
            descripcion: null,
            adicionalesDialog: false,
            textoAdicional: null
        }
    },
    planillaService: null,
    documentoService: null,
    created() {
        this.planillaService = new PlanillaService();
        this.documentoService = new DocumentoService();
    },
    mounted() {
        this.cargarDatosIniciales();
        this.cargarDocumento();
    },
    components: {
		'DialogProgreso': DialogProgreso
	},
    destroyed(){
    },
    methods:{
        cargarDatosIniciales(){
            this.showProgreso = true;
            this.mensajeCargando = "Cargando datos";
            this.planillaService.consultardetalleplanilla(this.cliente.id, this.anio.id, this.mes.id).then( response => {
                this.dataValoresAdicionales = response.data;
                this.showProgreso = false;
            }).catch( error => {
                console.log(error);
            });
        },

        cargarDocumento(){
            this.documentoLista = [];
            this.documentoService.consultardocumento().then( response => {
                this.documentoLista = response.data;
            } ).catch( error => {
                console.log(error);
            });
        },

        eliminar( data ){
            if(data.iddocumento == 2){
				Swal.fire({position: 'top', title: 'Advertencia!', text: "No se puede eliminar la lectura", icon: 'warning', showConfirmButton: true, timer: 6000});
				return;
			}
            let datos = {
                planillas: this.dataValoresAdicionales,
                planillaeliminar: data
            }
            this.planillaService.eliminarDetallePlanilla(datos).then( response => {
                let data = response.data;
                if( data.estado == "ok" ){
                    Swal.fire({ position: 'center', customClass: { container: 'my-swal' }, title: 'Correcto!', text: "" + data.mensaje + "", icon: 'success', showConfirmButton: true, timer: 6000 });
                    this.cargarDatosIniciales();
                }else{
                    Swal.fire({ position: 'center', title: 'Advertencia!', text: "Error al grabar", icon: 'warning', showConfirmButton: true, timer: 6000 });
                }
            }).catch( error => {
                console.log(error);
                Swal.fire({ position: 'center', title: 'Advertencia!', text: "Error al grabar", icon: 'warning', showConfirmButton: true, timer: 6000 });
            });
        },

        grabarDetallePlanilla(){
            if( this.valorunitario == null ||  this.valorunitario == "" || this.valorunitario == undefined ){
				Swal.fire({position: 'top', title: 'Advertencia!', text: "Debe registral valor unitario", icon: 'warning', showConfirmButton: true, timer: 6000});
				return;
			}
            if( this.cantidad == null ||  this.cantidad == "" || this.cantidad == undefined ){
				Swal.fire({position: 'top', title: 'Advertencia!', text: "Debe registral cantidad", icon: 'warning', showConfirmButton: true, timer: 6000});
				return;
			}
            if( this.descripcion == null ||  this.descripcion == "" || this.descripcion == undefined ){
				Swal.fire({position: 'top', title: 'Advertencia!', text: "Debe registral descripción", icon: 'warning', showConfirmButton: true, timer: 6000});
				return;
			}
            let data = {
                valorunitario: this.valorunitario,
                cantidad: this.cantidad,
                cliente: this.cliente,
                mes: this.mes,
                anio: this.anio,
                descripcion: this.descripcion,
                detalle: this.dataValoresAdicionales,
                documento: this.documentoSeleccionado
            }
            this.planillaService.grabarDetallePlanilla(data).then( response => {
                let data = response.data;
                if( data.estado == "ok" ){
                    Swal.fire({ position: 'center', customClass: { container: 'my-swal' }, title: 'Correcto!', text: "" + data.mensaje + "", icon: 'success', showConfirmButton: true, timer: 6000 });
                    this.cargarDatosIniciales();
                    this.adicionalesDialog = false;
                }else{
                    Swal.fire({ position: 'center', title: 'Advertencia!', text: "Error al grabar", icon: 'warning', showConfirmButton: true, timer: 6000 });
                }
            }).catch( error => {
                console.log(error);
                Swal.fire({ position: 'center', title: 'Advertencia!', text: "Error al grabar", icon: 'warning', showConfirmButton: true, timer: 6000 });
            });
        },

        nuevoRegistro(){
            this.adicionalesDialog = true;
            this.documentoSeleccionado = {};
            this.valorunitario = null;
            this.cantidad = null;
            this.descripcion = null;
            this.textoAdicional = "Agregar item";
        },

        cerrarModalItem(){
            this.adicionalesDialog = false;
        }
    },

    filters: {
        dosDecimales: function(value) {
            if(value == null || value == undefined) return "";
            value = value.toFixed(2)
            return value;
        },
    }
}
</script>
<style scoped lang="scss">
/deep/ .p-progressbar {
	height: .5rem;
	background-color: #D8DADC;
	.p-progressbar-value {
		background-color: #607D8B;
	}
}
.table-header {
	display: flex;
	justify-content: space-between;
}
/deep/ .p-datatable.p-datatable-customers {
	.p-datatable-header {
		padding: 1rem;
		text-align: left;
		font-size: 1.5rem;
	}
	.p-paginator {
		padding: 1rem;
	}
	.p-datatable-thead > tr > th {
		text-align: left;
	}
	.p-datatable-tbody > tr > td {
		cursor: auto;
	}
	.p-dropdown-label:not(.p-placeholder) {
		text-transform: uppercase;
	}
}
/* Responsive */
.p-datatable-customers .p-datatable-tbody > tr > td .p-column-title {
    display: none;
    
    
}
.customer-badge {
	border-radius: 2px;
	padding: .25em .5rem;
	font-weight: 700;
	font-size: 12px;
	letter-spacing: .3px;
	&.status-qualified {
		background: #C8E6C9;
		color: #256029;
	}
	&.status-0 {
		background: #FFCDD2;
		color: #C63737;
	}
	&.status-negotiation {
		background: #FEEDAF;
		color: #8A5340;
	}
	&.status-1 {
		background: #B3E5FC;
		color: #23547B;
	}
	&.status-renewal {
		background: #ECCFFF;
		color: #694382;
	}
	&.status-proposal {
		background: #FFD8B2;
		color: #805B36;
	}
}
.p-progressbar-value.ui-widget-header {
	background: #607d8b;
}
@media (max-width: 640px) {
	.p-progressbar {
		margin-top: .5rem;
	}
}
.product-image {
	width: 100px;
	box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)
}
.orders-subtable {
	padding: 1rem;
}
.product-badge {
	border-radius: 2px;
	padding: .25em .5rem;
	text-transform: uppercase;
	font-weight: 700;
	font-size: 12px;
	letter-spacing: .3px;
	&.status-instock {
		background: #C8E6C9;
		color: #256029;
	}
	&.status-outofstock {
		background: #FFCDD2;
		color: #C63737;
	}
	&.status-lowstock {
		background: #FEEDAF;
		color: #8A5340;
	}
}
.order-badge {
	border-radius: 2px;
	padding: .25em .5rem;
	text-transform: uppercase;
	font-weight: 700;
	font-size: 12px;
	letter-spacing: .3px;
	&.order-delivered {
		background: #C8E6C9;
		color: #256029;
	}
	&.order-cancelled {
		background: #FFCDD2;
		color: #C63737;
	}
	&.order-pending {
		background: #FEEDAF;
		color: #8A5340;
	}
	&.order-returned {
		background: #ECCFFF;
		color: #694382;
	}
}

@media screen and (max-width: 960px) {
	/deep/ .p-datatable {
		&.p-datatable-customers {
			.p-datatable-thead > tr > th,
			.p-datatable-tfoot > tr > td {
				display: none !important;
			}
			.p-datatable-tbody > tr {
				> td {
					text-align: left;
					display: block;
					border: 0 none !important;
					width: 100% !important;
					float: left;
					clear: left;
					border: 0 none;
					.p-column-title {
						
						min-width: 30%;
						display: inline-block;
						
						font-weight: bold;
					}
					.p-progressbar {
						margin-top: .5rem;
					}
				}
			}
		}
	}
}
</style>